<template>
	<el-tabs v-model="activeName" type="card">
		<el-tab-pane label="Check Rule" name="first">
			<el-row>
				<el-col :span="24">
					<el-form :inline="true" :model="filters" label-width="100px">
						<el-form-item><el-button type="primary" v-on:click="toAdd()">Add</el-button></el-form-item>
					</el-form>
				</el-col>
				<el-col :span="24">
					<el-table ref="multipleTable" :data="tableData" @row-click="toDetail" tooltip-effect="dark" style="width: 100%">
						<el-table-column prop="sRuleName" label="Rule Name"></el-table-column>
						<el-table-column prop="sSchema" label="Schema"></el-table-column>
						<el-table-column prop="sTableName" label="Table"></el-table-column>
						<el-table-column prop="sFieldName" label="Column"></el-table-column>
					</el-table>
				</el-col>
				<el-col :span="24">
					<div style="float: right;margin-top:20px;">
						<el-pagination @current-change="handleCurrentChange" background layout="prev, pager, next" :total="total"></el-pagination>
					</div>
				</el-col>
			</el-row>
			<el-dialog title="Add Check Rule" :visible.sync="addTableFlag" width="80%">
				<div>
					<el-form :model="form" ref="form" label-width="160px">
						<el-form-item label="Rule Name." prop="sRuleName"><el-input v-model="form.sRuleName" placeholder=""></el-input></el-form-item>
						<el-form-item label="Schema." prop="sSchema">
							<el-select v-model="form.sSchema" placeholder="Select">
								<el-option v-for="(item, index) in tableData1" :key="index" :label="item.sSchema" :value="item.sSchema"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="Table Name." prop="sTableName">
							<el-select v-model="form.sTableName" placeholder="Select">
								<el-option v-for="(item, index) in tableData2" :key="index" :label="item.sName" :value="item.sSelectName"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="Column Name." prop="sFieldName"><el-input v-model="form.sFieldName" placeholder=""></el-input></el-form-item>
						<el-form-item label="Desc." prop="sDesc"><el-input v-model="form.sDesc" placeholder=""></el-input></el-form-item>
					</el-form>
				</div>
				<span slot="footer" class="dialog-footer">
					<el-button @click="addTableFlag = false">Cancel</el-button>
					<el-button type="primary" @click="saveTable">Confirm</el-button>
				</span>
			</el-dialog>
			<el-dialog title="View Check Rule" :visible.sync="viewTableFlag" width="80%">
				<div>
					<el-form :model="form" ref="form" label-width="160px">
						<el-form-item label="Rule Name." prop="sRuleName">{{ form.sRuleName }}</el-form-item>
						<el-form-item label="Schema." prop="sSchema">{{ form.sSchema }}</el-form-item>
						<el-form-item label="Table Name." prop="sTableName">{{ form.sTableName }}</el-form-item>
						<el-form-item label="Column Name." prop="sFieldName">{{ form.sFieldName }}</el-form-item>
						<el-form-item label="Desc." prop="sDesc">{{ form.sDesc }}</el-form-item>
					</el-form>
				</div>
				<span slot="footer" class="dialog-footer">
					<el-button @click="viewTableFlag = false">Cancel</el-button>
					<el-button type="primary" @click="toEdit">Edit</el-button>
					<el-button type="primary" @click="toDelete">Delete</el-button>
				</span>
			</el-dialog>
			<el-dialog title="Edit Check Rule" :visible.sync="editTableFlag" width="80%">
				<div>
					<el-form :model="form" ref="form" label-width="160px">
						<el-form-item label="Rule Name." prop="sRuleName"><el-input v-model="form.sRuleName" placeholder=""></el-input></el-form-item>
						<el-form-item label="Schema." prop="sSchema">
							<el-select v-model="form.sSchema" placeholder="Select">
								<el-option v-for="(item, index) in tableData1" :key="index" :label="item.sSchema" :value="item.sSchema"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="Table Name." prop="sTableName">
							<el-select v-model="form.sTableName" placeholder="Select">
								<el-option v-for="(item, index) in tableData2" :key="index" :label="item.sName" :value="item.sSelectName"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="Column Name." prop="sFieldName"><el-input v-model="form.sFieldName" placeholder=""></el-input></el-form-item>
						<el-form-item label="Desc." prop="sDesc"><el-input v-model="form.sDesc" placeholder=""></el-input></el-form-item>
					</el-form>
				</div>
				<span slot="footer" class="dialog-footer">
					<el-button @click="editTableFlag = false">Cancel</el-button>
					<el-button type="primary" @click="saveEditTable">Confirm</el-button>
				</span>
			</el-dialog>
		</el-tab-pane>
	</el-tabs>
</template>

<script>
import { addCurrencyCheckRule, modifyCurrencyCheckRule, getCurrencyCheckRulePage, deleteCurrencyCheckRule, getDatabaseInfoList, getSelectList } from '../../api/api';
export default {
	data() {
		return {
			addTableFlag: false,
			viewTableFlag: false,
			editTableFlag: false,
			form: {
				sDesc: '',
				sFieldName: '',
				sRuleName: '',
				sSchema: '',
				sTableName: ''
			},
			activeName: 'first',
			tableData1: [],
			tableData2: [],
			filters: {
				pageSize: 10,
				currentPage: 1
			},
			total: 0,
			tableData: []
		};
	},
	watch: {
		'form.sSchema': function(newV, oldV) {
			if (newV != oldV) {
				this.form.sTableName = '';
				this.tableData2 = [];
				getSelectList({
					currentPage: 1,
					nSelectType: 1,
					sSchema: newV,
					pageSize: 9999
				}).then(res => {
					this.tableData2 = res.data;
				});
			}
		}
	},
	mounted() {
		this.getList();
		getDatabaseInfoList({
			currentPage: 1,
			pageSize: 9999
		}).then(res => {
			this.tableData1 = res.data;
		});
	},
	methods: {
		handleCurrentChange(page) {
			this.filters.currentPage = page;
			this.getList();
		},
		toDetail(row) {
			this.form = row;
			this.viewTableFlag = true;
		},
		toEdit() {
			this.editTableFlag = true;
			this.viewTableFlag = false;
		},
		toDelete() {
			var _this = this;
			this.$confirm('Confirm to Delete ?', 'Tips', {
				type: 'warning',
				customClass: 'customConfimClass'
			})
				.then(() => {
					deleteCurrencyCheckRule(this.form).then(res => {
						this.viewTableFlag = false;
						this.getList();
					});
				})
				.catch(() => {});
		},
		toAdd: function() {
			this.form = {
				sDesc: '',
				sFieldName: '',
				sRuleName: '',
				sSchema: '',
				sTableName: ''
			};
			this.addTableFlag = true;
		},
		saveEditTable() {
			if (!this.form.sRuleName) {
				return this.$message.error('Please enter the rule name');
			}
			if (!this.form.sSchema) {
				return this.$message.error('Please select the schema');
			}
			if (!this.form.sTableName) {
				return this.$message.error('Please select the table');
			}
			if (!this.form.sFieldName) {
				return this.$message.error('Please enter the column name');
			}
			modifyCurrencyCheckRule(this.form).then(res => {
				this.editTableFlag = false;
				this.getList();
			});
		},
		saveTable() {
			if (!this.form.sRuleName) {
				return this.$message.error('Please enter the rule name');
			}
			if (!this.form.sSchema) {
				return this.$message.error('Please select the schema');
			}
			if (!this.form.sTableName) {
				return this.$message.error('Please select the table');
			}
			if (!this.form.sFieldName) {
				return this.$message.error('Please enter the column name');
			}
			addCurrencyCheckRule(this.form).then(res => {
				this.addTableFlag = false;
				this.getList();
			});
		},
		getList: function() {
			var param = Object.assign({}, this.filters);
			getCurrencyCheckRulePage(param).then(res => {
				this.tableData = res.data;
				this.total = res.page.totalCount * 1;
			});
		}
	}
};
</script>

<style></style>



// WEBPACK FOOTER //
// check.vue?11a2223a